<template>
    <div container--fluid>
        <!-- <v-layout> -->
        <DonationModule></DonationModule>
        <!-- </v-layout> -->
    </div>
</template>

<script>
import DonationModule from "@modules/donation/index.vue";

export default {
    name: "donation",
    components: {
        DonationModule,
    },
    props: {
        //props
    },
    data() {
        return {
            //
        };
    },
    methods: {
        //methods
    },
};
</script>

<style scoped></style>
